import { useState } from "react";
import "../styles/contact.css";
import EmailMenu from "../components/EmailMenu";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function Contact() {
  const [form, setForm] = useState({
    name: "", company: "", phone: "", email: "",
    truckCount: "", services: [], notes: ""
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const toggleService = (s) => setForm((f) => ({
    ...f,
    services: f.services.includes(s) ? f.services.filter((x) => x !== s) : [...f.services, s],
  }));

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.phone || form.services.length === 0) {
      setError("Please fill in your name, email, phone, and select at least one service.");
      return;
    }
    setError("");
    setSending(true);

    try {
      const res = await fetch(API_URL + "/api/service-request", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const result = await res.json();

      if (!res.ok) throw new Error(result.error || "Server error");

      setSubmitted(true);
    } catch (err) {
      setError("Something went wrong. Please try again or call us directly at (704) 555-0199.");
    } finally {
      setSending(false);
    }
  };

  if (submitted) return (
    <div className="contact__success">
      <div>
        <div className="contact__success-icon">✅</div>
        <h2 className="contact__success-title">Request Sent!</h2>
        <p className="contact__success-text">
          Thank you, {form.name}! Your service request has been emailed to our team as a PDF. We will be in touch within 1 business day.
        </p>
        <button className="contact__success-btn"
          onClick={() => {
            setSubmitted(false);
            setForm({ name: "", company: "", phone: "", email: "", truckCount: "", services: [], notes: "" });
          }}>
          Submit Another Request
        </button>
      </div>
    </div>
  );

  return (
    <div className="contact">
      <div className="contact__header">
        <p className="contact__eyebrow">GET IN TOUCH</p>
        <h1 className="contact__title">Request Service</h1>
        <p className="contact__subtitle">Fill out the form below and we will generate a service request PDF and send it directly to our team.</p>
      </div>

      <div className="contact__card">
        <h3 className="contact__section-title">Contact Information</h3>
        <div className="contact__grid">
          {[
            ["Full Name *",          "name",    "text",  "John Smith"],
            ["Company / Fleet Name", "company", "text",  "Smith Logistics LLC"],
            ["Phone Number *",       "phone",   "text",  "(704) 555-0100"],
            ["Email Address *",      "email",   "email", "john@company.com"],
          ].map(([label, key, type, ph]) => (
            <div key={key} className="contact__field">
              <label className="contact__label">{label}</label>
              <input type={type} placeholder={ph} value={form[key]}
                onChange={(e) => set(key, e.target.value)} className="contact__input" />
            </div>
          ))}
        </div>

        <hr className="contact__divider" />
        <h3 className="contact__section-title">Service Details</h3>

        <div className="contact__grid">
          <div className="contact__field">
            <label className="contact__label">Number of Trucks</label>
            <input type="number" min="1" placeholder="e.g. 3" value={form.truckCount}
              onChange={(e) => set("truckCount", e.target.value)} className="contact__input" />
        </div>
        </div>

        <div className="contact__field">
          <label className="contact__services-label">Services Requested *</label>
          <div className="contact__services-grid">
            {["Repair", "Service", "Wash/Detailing"].map((s) => (
              <label key={s} className={"contact__service-option" + (form.services.includes(s) ? " contact__service-option--selected" : "")}>
                <input type="checkbox" checked={form.services.includes(s)} onChange={() => toggleService(s)} />
                <span>{s}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="contact__field">
          <label className="contact__label">Additional Notes</label>
          <textarea placeholder="Describe any specific concerns or scheduling preferences..."
            value={form.notes} onChange={(e) => set("notes", e.target.value)}
            className="contact__textarea" />
        </div>

        {error && <div className="contact__error">{error}</div>}

        <button onClick={handleSubmit} disabled={sending}
          className={"contact__submit" + (sending ? " contact__submit--disabled" : "")}>
          {sending ? "Sending..." : "📤 Submit & Email PDF"}
        </button>

        <p className="contact__submit-hint">
          A branded PDF of your request will be automatically emailed to our team.
        </p>
      </div>

      <div className="contact__info-bar">
        <div className="contact__info-card">
          <div className="contact__info-icon">📧</div>
          <div className="contact__info-label">EMAIL</div>
          <div className="contact__info-value"><EmailMenu /></div>
        </div>
        <div className="contact__info-card">
          <div className="contact__info-icon">📍</div>
          <div className="contact__info-label">LOCATION</div>
          <div className="contact__info-value">Statesville, NC</div>
        </div>
      </div>
    </div>
  );
}